import { Component, Inject, Injectable } from '@angular/core';
import { MAT_LEGACY_SNACK_BAR_DATA as MAT_SNACK_BAR_DATA, MatLegacySnackBar as MatSnackBar, MatLegacySnackBarRef as MatSnackBarRef } from '@angular/material/legacy-snack-bar';
import { Message, NotificationHelper } from '../notification-helper';
import { Observable } from 'rxjs';

@Component({
   selector: 'app-push-notify',
   templateUrl: './push-notify.component.html',
   styleUrls: ['./push-notify.component.scss']
})
export class PushNotifyComponent {
   data: any;

   constructor(private snackBarRef: MatSnackBarRef<PushNotifyComponent>,
               @Inject(MAT_SNACK_BAR_DATA) private message: Message, public helper: NotificationHelper) {
      this.data = message.payload;
   }

   action(): void {
      this.helper.doAction(this.message);
      this.snackBarRef.dismissWithAction();
   }

   getCursor(): string {
      return this.helper.getCursor(this.message.payload);
   }

   dismiss(): void {
      this.snackBarRef.dismiss();
   }
}

@Injectable({ providedIn: 'root' })
export class PushNotify {
   constructor(private snackBar: MatSnackBar) {}

   show(message: Message): Observable<void> {
      const snackBarRef = this.snackBar.openFromComponent(PushNotifyComponent, {
         data: message,
         duration: 10000,
         horizontalPosition: 'left',
         panelClass: 'notify-panel'
      });
      return snackBarRef.onAction();
   }
}
